import clsx from 'clsx';
import React from 'react';

import { ContentfulTextContainer } from '../ContentfulTextContainer';
import { FAQItem } from '../FAQItem';

type FAQSectionProps = {
  items?: any[];
  preHeader?: string;
  title?: string;
  titleClassName?: string;
};

const FAQSection = ({
  items = [],
  preHeader,
  title = 'Have questions? We have answers.',
  titleClassName = 'w-[14ch]',
}: FAQSectionProps) => {
  return (
    <section
      className={
        'pt-10 pb-7 px-4 rounded-t-3xl bg-[#F6F6F1] md:pt-20 md:pb-[120px] md:px-20 md:rounded-none'
      }
    >
      <div className="width-1440">
        {preHeader ? <div className="mb-2 text-xs font-light">{preHeader}</div> : null}

        <h2
          className={clsx(
            'modernGothicTrial-light text-[28px] md:text-[48px] md:leading-snug md:mb-11',
            titleClassName
          )}
        >
          {title}
        </h2>
        {items.map((item) => (
          <FAQItem
            key={item.headline}
            headline={item.headline}
            content={
              <div className="modernGothicTrial-light">
                <ContentfulTextContainer markdown={item.text} />
              </div>
            }
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
